import { Head } from "@inertiajs/react";

export default function PublicPagesIndex({
  public_pages,
}) {
  return (
    <>
      <Head>
        <title>Страницы</title>
      </Head>

      <div className="table-header">
        <div className="table-header__left">
          <h2>Страницы</h2>
        </div>
      </div>

      <table className="tbl">
        <tbody>
          {public_pages.map((page) => (
            <tr key={page.id}>
              <td>{page.title_ru}</td>
              <td className="tbl-extra">
                <div className="flex-row gap-3">
                  <a href={`/admin/public_pages/${page.codename}/edit`} className="lnk lnk--blue">Редактировать</a>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
